import { InlineLink, Strong } from '@utilitywarehouse/hearth-react';

export const getDefaultLegalContent = () => (
  <>
    <Strong>£400 to help you switch:</Strong> When you take a 3 or 4+ Service
    Bundle, we&apos;ll give you credit up to £400 towards any termination fees
    (excluding Home Insurance) you have to pay your current providers.
    You&apos;ll need to return any equipment and pay for services you used
    before you cancel. Additional requirements apply to customers who are
    tenants. Further terms apply see our Residential Products and Services terms
    and conditions here.
    <br />
    <br />
    <Strong>Cheapest variable energy:</Strong> When you take energy and two
    other eligible bundle services vs standard variable tariffs offered by major
    suppliers (large and medium suppliers as defined by Ofgem), for sale
    nationally, excl. existing customer tariffs. Based on Ofgem&apos;s typical
    domestic usage. Payment by Direct Debit. Correct as of 03/02/2025. Contact
    us to verify. See UW{' '}
    <InlineLink
      href="https://uw.co.uk/legal/information-legal"
      target="_blank"
      rel="noopener noreferrer"
    >
      terms and conditions.
    </InlineLink>
  </>
);
